<template>
  <f7-list form list-media outline dividers strong inset>
    <f7-list-input :label="$t('shopproductaddnew.sku') || 'SKU'" type="text" :value="modelValue.sku" @input="$emit('update:modelValue', { ...modelValue, sku: $event.target.value })" class="input-field" />
    <f7-list-input :label="$t('shopproductaddnew.variant') || 'Variant name'" type="text" :value="modelValue.name" @input="$emit('update:modelValue', { ...modelValue, name: $event.target.value })" class="input-field" />
    <f7-list-input :label="$t('catalogImport.attributesJson') || 'Attributes JSON'" type="text" :value="modelValue.attributesJson" @input="$emit('update:modelValue', { ...modelValue, attributesJson: $event.target.value })" class="input-field" />
    <f7-list-input :label="$t('shopproductaddnew.qty') || 'Stock'" type="number" :value="modelValue.stockQuantity" @input="$emit('update:modelValue', { ...modelValue, stockQuantity: Number($event.target.value) })" class="input-field" />
    <div class="padding">
      <f7-list-input type="file" multiple accept="image/*" @change="$emit('media', Array.from($event.target.files || []))" />
    </div>
    <f7-button small round raised color="red" @click="$emit('remove')">{{ $t('common.delete') || 'Remove variant' }}</f7-button>
  </f7-list>
</template>

<script setup>
defineProps({ modelValue: Object })
defineEmits(['update:modelValue', 'media', 'remove'])
</script>

<style scoped>
.input-field { width: 100%; padding: 6px; border: 1px solid var(--f7-list-input-border-color, #ccc); border-radius: 6px; }
</style>
